module.exports = __webpack_public_path__ + "img/dots_lbb4.8e15af53.png";